<template>
  <div class="zpxq">
    <div v-if="facility=='app'" class="content"> 
    </div>
    <div class="pc" v-else>
      <Pc />
    </div>
  </div>
</template>

<script>
import Pc from "./pc";
export default {
  components:{
    Pc
  },
  data(){
    return{
      facility:""
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  methods:{
    
  }
}
</script>

<style>

</style>